import {Bootstrap} from "./Bootstrap";

export class AfterFacility {
	
	
	static init() {
		AfterFacility.initAfter();
	}
	
	
	static id = 1;
	static list;
	static icons;
	static wrap;
	static scrollY;
	static nav;
	static navWrap;
	static prev;
	static next;
	
	static initAfter() {
		const afFacility = document.querySelector('[data-role="afFacility"]');
		if(!afFacility) {
			return;
		}
		
		this.prev = afFacility.querySelector('.af-facility-list__prev');
		this.next = afFacility.querySelector('.af-facility-list__next');
		
		this.list = afFacility.querySelector('.af-facility-list');
		if (typeof this.list == "undefined") {
			return;
		}
		this.icons = afFacility.querySelectorAll('.af-facility__icon');
		this.wrap = this.list.querySelector('.af-facility-list__wrap');
		
		this.navWrap = afFacility.querySelector('.af-facility');
		this.nav = afFacility.querySelector('.af-facility__nav');
		afFacility.querySelectorAll('.af-facility__btn').forEach((btn) => {
			btn.addEventListener('click',(e)=>{
				this.selectAfter(e);
				e.stopPropagation();
			});
		});
		this.list.querySelectorAll('.af-facility-list__item').forEach((item)=>{
			item.addEventListener('click',this.selectAfter.bind(this));
		});
		
		this.nav.addEventListener('click',(e)=>{
			if(!Bootstrap.isSmartPhone()) return;
			if(this.navWrap.classList.contains('is-open')){
				this.navWrap.classList.remove('is-open')
			}else{
				window.scrollTo(
					0,
					this.nav.getBoundingClientRect().top + window.pageYOffset - document.querySelector('.header').clientHeight
					);
				this.navWrap.classList.add('is-open');
			}
		});
		
		this.nav.querySelector('.af-facility__btn').click();
		
		this.prev.addEventListener('click',()=>{
			this.changeAfter(parseInt(this.id)-1);
		});
		this.next.addEventListener('click',()=>{
			this.changeAfter(parseInt(this.id)+1);
		});
		
	}
	
	static selectAfter(e) {
		let id = e.currentTarget.dataset.id;
		this.changeAfter(id);
	}
	static changeAfter(id) {
		this.id = id;
		this.icons.forEach((el)=>{
			if(el.dataset.id==id){
				el.classList.add('is-active');
			}else{
				el.classList.remove('is-active');	
			}
		});
		
		if(Bootstrap.isSmartPhone()){
			this.navWrap.classList.remove('is-open');
			this.navWrap.classList.add('is-scroll');
			let target = this.navWrap.querySelector('.af-facility__btn[data-id="'+id+'"]');
			var offsetTop = target.offsetTop;
			setTimeout(()=>{
				this.nav.scrollTop = offsetTop;
				setTimeout(()=>{
					this.navWrap.classList.remove('is-scroll');
				},50);
			},50);
		}
		
		this.list.querySelectorAll('.af-facility-list__item').forEach((el) => {
			el.classList.remove('is-active');
		});
		let item = this.list.querySelector('[data-id="' + id + '"]');
		item.classList.add('is-active');
		let left = (-item.clientWidth * id) + (item.clientWidth / 2);
		this.wrap.style.marginLeft = left + 'px';
		
		this.prev.classList.remove('is-disabled');
		this.next.classList.remove('is-disabled');
		if(this.id==1){
			this.prev.classList.add('is-disabled');
		}
		if(this.id >=this.icons.length){
			this.next.classList.add('is-disabled');
		}
		
	}
	
	
} 